<script lang="ts">
    import type { WhatWhoQueryQuery } from '$gql/graphql.js';
    import type { IterableElement } from 'type-fest';
    import MediaImage from '$components/MediaImage/MediaImage.svelte';
    import Highlighter from '$components/Highlighter.svelte';
    import { cx } from '$lib/utils/cx';

    let className = '';
    export { className as class };

    export let query: string | null = null;
    export let option: IterableElement<WhatWhoQueryQuery['searchHeader']['whatWho']>;

    function getImageId(o: typeof option) {
        if (o.user != null) {
            return o.user.profilePhoto?.id ?? null;
        } else if (o.company != null) {
            return o.company.squarePhoto?.id ?? null;
        } else if (o.shoppingProduct != null) {
            return o.shoppingProduct?.image?.id ?? null;
        }
        return null;
    }

    function getText(o: typeof option) {
        if (o.user != null) {
            return o.user.fullname ?? '';
        } else if (o.company != null) {
            return o.company.name;
        } else if (o.category) {
            return o.category.name;
        } else if (o.shoppingProduct) {
            return o.shoppingProduct.name;
        } else if (o.jobOffer) {
            return o.jobOffer.title;
        } else if (o.text != null) {
            return o.text;
        }

        return '';
    }

    function getSubtext(o: typeof option) {
        if (o.user != null) {
            return o.user.participantTitle;
        } else if (o.company != null) {
            return o.company.participantTitle;
        }

        return null;
    }

    $: imageId = getImageId(option);
    $: subtext = getSubtext(option);
    $: text = getText(option);
</script>

<div class={cx('flex items-center px-[20px] gap-[8px]', className)}>
    {#if imageId != null}
        <MediaImage
            mediaId={imageId}
            format="w100"
            alt={text}
            class="w-[42px] h-[42px] object-cover shrink-0"
        />
    {/if}

    <div>
        <div class="text-black text-13 leading-[18px]">
            <Highlighter {text} {query} class="m-0 p-0" highlightClass="font-bold" />
        </div>
        {#if subtext != null}
            <div class={'text-gray-700 text-12 leading-[18px] line-clamp-1'}>
                <Highlighter
                    text={subtext}
                    {query}
                    class="m-0 p-0"
                    highlightClass="font-bold"
                />
            </div>
        {/if}
    </div>
</div>
